import { render } from "./EditingMediaSeason.vue?vue&type=template&id=b36db02e"
import script from "./EditingMediaSeason.vue?vue&type=script&lang=js"
export * from "./EditingMediaSeason.vue?vue&type=script&lang=js"
script.render = render

export default script